module.exports = __webpack_public_path__ + "img/icon-map-implantation-14.e7df409f.svg";